export default "__VITE_ASSET__mjRxnMN7__"